<script setup lang="ts">

interface Props {
    width?: string
    theme?: string
}

const props = withDefaults(defineProps<Props>(), {
    width: '36',
    theme: 'light'
})
</script>

<template>
    <img
        v-if="props.theme === 'dark'"
        src="@/assets/logo-dark.png"
        :width="width"
        alt="logo"
    >
    <img
        v-if="props.theme === 'light'"
        src="@/assets/logo-light.png"
        :width="width"
        alt="logo"
    >
</template>

<style scoped>

</style>
